(function () {
  'use strict';
  if (window.DDXCartCoordinator) return;

  var LOCK_KEY = '__ddxCartMutationLock';
  var DEFAULT_TTL_MS = 8000;

  function now() {
    return Date.now();
  }

  function getCurrent() {
    var current = window[LOCK_KEY];
    if (!current) return null;
    if (current.expiresAt <= now()) {
      delete window[LOCK_KEY];
      return null;
    }
    return current;
  }

  function tryAcquire(source, opts) {
    var options = opts || {};
    if (getCurrent()) return null;
    var token = {
      id: String(now()) + '-' + Math.random().toString(36).slice(2, 8),
      source: source || 'unknown',
      acquiredAt: now(),
      expiresAt: now() + (options.ttlMs || DEFAULT_TTL_MS),
    };
    window[LOCK_KEY] = token;
    return token;
  }

  function release(tokenOrSource) {
    var current = getCurrent();
    if (!current) return;
    if (!tokenOrSource) {
      delete window[LOCK_KEY];
      return;
    }
    if (typeof tokenOrSource === 'string') {
      if (current.source === tokenOrSource || current.expiresAt <= now()) {
        delete window[LOCK_KEY];
      }
      return;
    }
    if (tokenOrSource.id && current.id === tokenOrSource.id) {
      delete window[LOCK_KEY];
    }
  }

  function withLock(source, task, opts) {
    var token = tryAcquire(source, opts);
    if (!token) return Promise.reject(new Error('lock_active'));
    var p;
    try {
      p = Promise.resolve(task(token));
    } catch (err) {
      release(token);
      throw err;
    }
    return p.finally(function () {
      release(token);
    });
  }

  window.DDXCartCoordinator = {
    DEFAULT_TTL_MS: DEFAULT_TTL_MS,
    getCurrent: getCurrent,
    isLocked: function () {
      return !!getCurrent();
    },
    tryAcquire: tryAcquire,
    release: release,
    withLock: withLock,
  };
})();
